import { useEffect, useState } from "react";
import "./inventory.scss";
import { DataGrid, GridMoreVertIcon } from "@mui/x-data-grid";
import { HiOutlineEye } from "react-icons/hi2";
import { CiEdit } from "react-icons/ci";
import { GoTrash } from "react-icons/go";
import { RxPlus } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Select,
  gridClasses,
  styled,
} from "@mui/material";
import { useAuth } from "../../../context/AuthProvider";
import { HttpService } from "../../../service/HttpService";
import { useFilter } from "../../../context/FilterProvider";
import { Encryption } from "../../../Mixin/EncryptDecryptId";
import { toast } from "react-toastify";
import FullScreenLoader from "../../../components/Loader/FullScreenLoader";
import DeleteModal from "../../../components/Model/DeleteModal";
import AddEditInventory from "../../../components/Inventory/AddEditInventory";
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
import QtyModal from "../QtyModal/QtyModal";
import { FaFileExcel } from "react-icons/fa";
import { handleDownloadInventoryExcel } from "../DownloadInventory";
dayjs.extend(utc);

const Inventory = () => {
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [openModel, setOpenModel] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [inventory_id, setInventory_Id] = useState("");
  const [DeleteInventory, setDeleteInventory] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataId, setDataId] = useState();
  const { company_id, location_id } = useFilter();
  const [openPurchaseModal, setOpenPurchaseModal] = useState(false);
  const [departments, setDepartment] = useState([]);
  const [departmentState, setDepartmentState] = useState([]);
  const [mode, setMode] = useState("purchased");
  const [itemsData, setItemsData] = useState({});
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [allIds, setAllIds] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [rowCount, setRowCount] = useState("");
  const [page, setPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  // Restore search from localStorage on mount
  useEffect(() => {
    const savedSearch = localStorage.getItem("inventorySearchTerm") || "";
    if (savedSearch) {
      setSearchTerm(savedSearch);
    }
  }, []);

  const fetchInventory = () => {
    setLoading(true);
    //  `inventory?department_id=${departmentState}&page=${
    //       page + 1
    //     }&pageSize=${pageSize}`
    httpService
      .get(`inventory?department_id=${departmentState}`)
      .then((response) => {
        setRows(response?.data?.rows); // Assuming the response data is an array of rows
        setSearchData(response?.data?.rows);
        setRowCount(response?.data?.total);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  const fetchDepartment = () => {
    setLoading(true);
    httpService
      .get("inventory/departments")
      .then((response) => {
        setDepartment(response.data); // Assuming the response is an array of rows
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };
  useEffect(() => {
    fetchInventory();
    fetchDepartment();
  }, [showLoginPopup, departmentState, page, pageSize]);

  // Uncomment and update the searchInventory function
  const searchInventory = (searchTerm) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    const results =
      rows?.length > 0 &&
      rows.filter((item) =>
        item.item_name?.toLowerCase().includes(searchTermLowerCase)
      );

    if (results) {
      setSearchData(results);
    }
  };

  // Add useEffect to trigger search when searchTerm changes
  useEffect(() => {
    if (searchTerm === "") {
      setSearchData(rows);
    } else {
      searchInventory(searchTerm);
    }
    // eslint-disable-next-line
  }, [searchTerm, rows]);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpen = () => {
    setOpenModel(true);
    setIsAdd(true);
    setInventory_Id("");
  };
  const handleClose = () => {
    setOpenModel(false);
    setIsAdd(false);
    setInventory_Id("");
    setOpenDelete(false);
    // fetchInventory();
  };

  const viewPage = (id) => {
    const urlEncodedId = Encryption(id);
    // Navigate to the encrypted URL
    navigate(`view/${urlEncodedId}`);
  };

  const HandleDeleteInventory = async () => {
    if (DeleteInventory) {
      try {
        const response = await httpService.delete(
          `${"inventory"}/${DeleteInventory}`
        );
        if (response) {
          fetchInventory();
          navigate("/inventory");
          toast.success("Inventory Deleted successfully", {
            position: "top-right",
          });
        } else {
          throw response;
        }
        setOpenDelete(false);
        fetchInventory();
      } catch (error) {
        setOpenDelete(false);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    }
  };

  const handleDepartmentFilter = (event) => {
    const {
      target: { value },
    } = event;

    if (value.includes("all")) {
      const allIds = departments.map((dept) => dept.id);
      setDepartmentState((prev) =>
        prev.length === allIds.length ? [] : allIds
      );
    } else {
      setDepartmentState(typeof value === "string" ? value.split(",") : value);
    }
  };

  const openUseQtyModal = (item) => {
    setOpenPurchaseModal(true);
    setMode("used");
    setItemsData(item);
  };

  const openPurchaseQtyModal = (item) => {
    setOpenPurchaseModal(true);
    setMode("purchased");
    setItemsData(item);
  };

  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allIds = rows.map((row) => row.id); // Get all the IDs from the data
      setSelectedId(allIds); // Select all IDs
      setAllIds(allIds.length);
    } else {
      setSelectedId([]);
      setAllIds(0);
    }

    setIsAllSelected(isChecked);
  };

  const toggleId = (id) => {
    const allIds = rows.map((row) => row.id);

    if (selectedId?.includes(id)) {
      // Remove the id from selectedId
      const updatedSelectedIds = selectedId.filter((item) => item !== id);

      setSelectedId(updatedSelectedIds);
      setIsAllSelected(updatedSelectedIds.length === allIds.length);
      setAllIds(allIds.length);

      return updatedSelectedIds;
    } else {
      // Add the id to selectedId
      const updatedSelectedIds = [...selectedId, id];

      setSelectedId(updatedSelectedIds);
      setIsAllSelected(updatedSelectedIds.length === allIds.length);
      setAllIds(allIds.length);

      return updatedSelectedIds;
    }
  };

  const isIdSelected = (id) => {
    return selectedId.includes(id);
  };

  const onDownloadClick = async () => {
    try {
      await handleDownloadInventoryExcel(setShowLoginPopup, selectedId);
      setSelectedId([]);
      setIsAllSelected(false);
      setAllIds(0);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Found</Box>
      </StyledGridOverlay>
    );
  }

  const other = {
    showCellVerticalBorder: true,
    showColumnVerticalBorder: true,
  };

  // return <h1>Coming Soon</h1>;

  return (
    <>
      {loading && <FullScreenLoader />}
      {/* Render spinner if loading is true */}
      <div className="inventories">
        <div className="page-title">
          <div className="title-wrap">
            <h1>Inventory</h1>
          </div>
          <div className="right_part" style={{ gap: "24px" }}>
            <div className="form_field_wrapper">
              <FormControl fullWidth>
                <Select
                  id="select-deaprtment"
                  name="department"
                  displayEmpty
                  multiple
                  value={departmentState} // Directly using departmentState
                  onChange={handleDepartmentFilter}
                  MenuProps={{
                    getcontentanchorel: null,
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    keepMounted: true,
                  }}
                  style={{ height: "49px" }}
                  renderValue={(selected) => {
                    if (selected?.length === 0) {
                      return <span>Select Departments</span>;
                    }
                    const selectedData =
                      selected &&
                      selected.map(
                        (id) => departments.find((item) => item.id === id)?.name
                      );
                    return selectedData?.join(", ");
                  }}
                >
                  <MenuItem value="" selected disabled>
                    Department
                  </MenuItem>
                  {departments && departments?.length > 0 && (
                    <MenuItem value="all">
                      <ListItemIcon>
                        <Checkbox
                          checked={
                            departmentState.length === departments?.length
                          }
                          indeterminate={
                            departmentState.length > 0 &&
                            departmentState.length < departments?.length
                          }
                        />
                      </ListItemIcon>
                      <ListItemText primary="Select All" />
                    </MenuItem>
                  )}
                  {departments?.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      <Checkbox
                        checked={
                          departmentState.length > 0 &&
                          departmentState.includes(item.id)
                        }
                      />
                      <ListItemText primary={item.label || item.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="button-wrap">
              <Button
                variant="contained"
                color="primary"
                onClick={() => onDownloadClick()}
                startIcon={<FaFileExcel />}
                className="me-1"
                disabled={selectedId?.length > 0 ? false : true}
              >
                Download
              </Button>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={() => handleOpen()}
              >
                <RxPlus /> Add Inventory
              </button>
            </div>
          </div>
        </div>
        <div className="table-filter-wrap d-flex justify-content-between">
          <div className="header_search-wrap">
            <div className="header_search_bar common_content">
              <div className="input-group input_group">
                <button className="btn search-btn search_btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <circle
                      cx="9.98856"
                      cy="9.98856"
                      r="8.98856"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.2402 16.7071L19.7643 20.222"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <input
                  type="search"
                  className="form-control form_control"
                  placeholder="Search Item Name"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchTerm(value);
                    localStorage.setItem("inventorySearchTerm", value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            height: `${searchData?.length > 0 ? "" : "200px"}`,
            width: "100%",
          }}
        >
          <DataGrid
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            rows={searchData?.length > 0 ? searchData : []}
            getRowHeight={() => "auto"}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 0.5,
              },
            }}
            columnHeaderHeight={60}
            columns={[
              {
                field: "action",
                headerName: "Actions",
                headerAlign: "center",
                align: "center",
                width: 100,
                disableColumnMenu: true,
                renderCell: (params) => (
                  <>
                    <div className="action_icon-weap">
                      <IconButton
                        onClick={(e) => {
                          handleMenuClick(e), setDataId(params.row.id);
                        }}
                      >
                        <GridMoreVertIcon />
                      </IconButton>
                    </div>
                    {anchorEl && dataId === params?.row?.id && (
                      <Popover
                        className="popup-menu"
                        key={dataId}
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleCloseMenu}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            viewPage(dataId);
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">View</div>
                          <HiOutlineEye style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            // console.log("params", params.row.id);
                            setOpenModel(true);
                            setIsAdd(false);
                            setInventory_Id(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Edit</div>
                          <CiEdit style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setOpenDelete(true);
                            setDeleteInventory(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Delete</div>
                          <GoTrash style={{ cursor: "pointer" }} />
                        </MenuItem>
                      </Popover>
                    )}
                  </>
                ),
                sortable: false,
              },
              {
                field: "select_All",
                headerName: "Select All",
                minWidth: 30,
                align: "center",
                sortable: false,
                headerAlign: "center",
                disableColumnMenu: true,
                renderCell: (params) => {
                  return (
                    <Checkbox
                      value="Checked"
                      checked={
                        isAllSelected
                          ? true
                          : isIdSelected(params.row.id)
                          ? true
                          : false
                      }
                      onChange={() => toggleId(params.row.id)}
                    />
                  );
                },
                headerCheckboxSelection: true,
                renderHeader: (params) => {
                  return (
                    <>
                      <Checkbox
                        checked={isAllSelected}
                        disabled={departmentState?.length > 0 ? false : true}
                        onChange={(e) => handleHeaderCheckboxChange(e)}
                      />
                      {/* <strong>Select All</strong> */}
                    </>
                  );
                },
              },
              {
                field: "item_name",
                headerName: "Item Name",
                width: 250,
                headerClassName: "colurs",
                filterable: true,
              },
              {
                field: "department_name",
                headerName: "Department",
                width: 200,
              },
              {
                field: "item_description",
                headerName: "Item Description",
                width: 410,
                sortable: true,
                headerAlign: "center",
                align: "center",
              },
              {
                field: "supplier",
                headerName: "Supplier Name",
                width: 150,
                sortable: true,
                headerAlign: "center",
                align: "center",
              },
              {
                field: "purchased_qty",
                headerName: "Purchased Qty",
                width: 210,
                sortable: false,
                renderCell: (params) => (
                  <div className="employee-name-weap">
                    {params.value ? (
                      <span
                        onClick={() => openPurchaseQtyModal(params.row)}
                        style={{
                          cursor: "pointer",
                          color: "#7171f1",
                          textDecorationLine: "underline",
                        }}
                      >
                        {parseFloat(params.value)}{" "}
                        <span>{params.row.unit_name}</span>
                      </span>
                    ) : (
                      <span
                        onClick={() => openPurchaseQtyModal(params.row)}
                        style={{
                          cursor: "pointer",
                          color: "#7171f1",
                          textDecorationLine: "underline",
                        }}
                      >
                        add purchased
                      </span>
                    )}
                  </div>
                ),
              },
              {
                field: "total_qty",
                headerName: "On Hand Qty",
                width: 200,
                sortable: false,
                renderCell: (params) => {
                  const value = params.value;
                  const isNumber = !isNaN(parseFloat(value)) && isFinite(value);
                  return (
                    <div className="employee-name-weap">
                      <span>
                        {isNumber
                          ? `${parseFloat(value)} ${params.row.unit_name || ""}`
                          : value || "--"}
                      </span>
                    </div>
                  );
                },
              },
              // {
              //   field: "used_qty",
              //   headerName: "Used Qty",
              //   width: 210,
              //   sortable: false,
              //   renderCell: (params) => (
              //     <div className="employee-name-weap">
              //       {params.value ? (
              //         <span
              //           onClick={() => openUseQtyModal(params.row)}
              //           style={{
              //             cursor: "pointer",
              //             color: "#7171f1",
              //             textDecorationLine: "underline",
              //           }}
              //         >
              //           {parseFloat(params.value)}{" "}
              //           <span>{params.row.unit_name}</span>
              //         </span>
              //       ) : (
              //         <span
              //           onClick={() => openUseQtyModal(params.row)}
              //           style={{
              //             cursor: "pointer",
              //             color: "#7171f1",
              //             textDecorationLine: "underline",
              //           }}
              //         >
              //           add used
              //         </span>
              //       )}
              //     </div>
              //   ),
              // },
            ]}
            // initialState={{
            //   pagination: {
            //     rowCount: -1,
            //   },
            // }}
            // paginationMode="server"
            sortingMode="client"
            // rowCount={rowCount}
            // pageSizeOptions={[15, 50, 100]}
            // paginationModel={{ pageSize: pageSize, page: page }}
            // onPaginationModelChange={(event) => {
            //   setPage(event?.page);
            //   setPageSize(event?.pageSize);
            // }}
            hideFooter
            hideFooterPagination={false}
            checkboxSelection={false}
            rowSelection={false}
            {...other}
          />
        </div>
      </div>
      {openModel === true && (
        <AddEditInventory
          open={openModel}
          isAdd={isAdd}
          inventory_id={inventory_id}
          handleClose={() => handleClose()}
          fetchInventory={() => fetchInventory()}
          locationId={location_id}
          companyId={company_id}
        />
      )}
      <DeleteModal
        open={openDelete}
        HandleClose={() => handleClose()}
        HandleDelete={() => {
          HandleDeleteInventory(), setInventory_Id("");
        }}
      />
      {openPurchaseModal && (
        <>
          <QtyModal
            open={openPurchaseModal}
            handleClose={() =>
              setOpenPurchaseModal((openPurchaseModal) => !openPurchaseModal)
            }
            itemDetails={itemsData}
            mode={mode}
            fetchInventory={() => fetchInventory()}
          />
        </>
      )}
    </>
  );
};

export default Inventory;
